// Common
import './lib/common/common.js';

// Load Web components
import '../components/kw-button-languages/kw-button-languages.js';
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-banner/kw-banner.js';
import '../components/kw-section/kw-section.js';
import '../components/kw-stage/kw-stage.js';

// Load libraries
import './lib/scroll/scroll.js';
import DataLanguage from './lib/data-language.js';
import dataBanner from './lib/dataBanner.js';
import dataBanners from '../json/ecommerceBannerData.json';

const { lang } = document.querySelector('html');

function banner() {
  const bannerData = document.getElementById('banner-ecommerce');
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="ecommerce">
              ${DataLanguage.dataLanguage(dataBanners.ecommerceBannerData, lang).map(dataBanner.banner).join('')}
          </kw-banner>
    `;
}

function addAnimationClass(baseClass) {
  document.querySelectorAll(`.${baseClass}`).forEach((ele) => ele.classList.add(`${baseClass}--animation`));
}

function weRoleSectionAnimation() {
  const querys = ['methodology', 'title-wrapper', 'cartoon', 'tools', 'toolset'];
  querys.forEach((query) => addAnimationClass(`ecommerce__our-role-${query}`));
}

function createObserver(element, callBack) {
  const interserctionObserver = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        interserctionObserver.unobserve(element);
        callBack();
      }
    },
  );
  interserctionObserver.observe(element);
}

function handleLoadWindowFunctions() {
  banner();
  const weRoleSection = document.querySelector('.ecommerce__our-role');
  createObserver(weRoleSection, weRoleSectionAnimation);
}

if (document.addEventListener) {
  window.addEventListener('load', handleLoadWindowFunctions);
}
